/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：683__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widgetName: "电话",
    phoneNumber: "号码",
    callNumber: "拨打电话",
    callNumberTooltip: "直接拨打“号码”属性中设置的电话号码。",
    dialNumber: "打开拨号界面",
    dialNumberTooltip: "打开系统自带的拨号界面。",
    onReceivePhoneCall: "收到来电",
    onConnectReceivePhoneCall: "接通来电",
    onPhoneCallStart: "拨出电话",
    onPhoneCallEnd: "挂断电话",
    onPhoneCallEndTooltip: "状态=1：来电未接或被拒绝\n状态=2：来电被接听后挂断\n状态=3：拨出电话后被对方挂断",
    state: "状态",
    phoneNumberNotEmpty: "号码不能为空哦",
    callNumberRepeat: "不能调用多个拨打电话积木，仅执行第一个",
    dialNumberRepeat: "不能调用多个拨号界面积木，仅执行最后一个"
  }
}
export { r }
